import React from "react";
import {
  executeQuoteDrawingWhatsAppIntent,
  setPendingQuoteDrawingWhatsAppIntent,
  storeQuoteDrawingWhatsAppUrl,
} from "../service";

/**
 * Catalog banner: sales-assisted quote from customer drawings via WhatsApp.
 * @param {{
 *   className?: string,
 *   isLoggedIn?: boolean,
 *   onAuthRequired?: () => void,
 * }} props
 */
export default function StoreQuoteDrawingAssistanceBanner({
  className,
  isLoggedIn = false,
  onAuthRequired,
}) {
  const whatsAppHref = storeQuoteDrawingWhatsAppUrl();

  const handleShareClick = (e) => {
    e.preventDefault();
    if (!isLoggedIn) {
      setPendingQuoteDrawingWhatsAppIntent();
      onAuthRequired?.();
      return;
    }
    executeQuoteDrawingWhatsAppIntent();
  };

  return (
    <div className={className}>
      <div
        className="rounded-3 p-2 border w-100"
        style={{
          background: "#FDEA9F",
          borderColor: "#fdea9f",
        }}
      >
        <div className="text-dark" style={{ letterSpacing: "0.01em" }}>
          <b>Need assistance with a quote for your project?</b>

          <p className="mb-2">
            Just share your drawing and our sales team will prepare a quote for
            you.{" "}
          </p>
          <a
            href={whatsAppHref}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleShareClick}
            className="fw-bold text-primary text-decoration-none d-inline-flex align-items-center gap-1"
          >
            <i className="fa-brands fa-whatsapp text-success" aria-hidden />
            Share a drawing
          </a>
        </div>
      </div>
    </div>
  );
}
